export const endPointsToIgnore = [
  `/${window.__APP_VERSION_FILE__}?v=`,
  '/record-tracking',
]

export const isDebugSentry =
  import.meta.env.DEV && import.meta.env.VITE_DEBUG_SENTRY === 'true'

export const isSentryEnabled = import.meta.env.PROD || isDebugSentry
